// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design';
//引入iview主题修改less文件
import '../iviewTheme.less';
import uploader from 'vue-simple-uploader';
//import 'lib-flexible'
//import './utils/flexible'


Vue.use(ViewUI);
Vue.use(uploader);

//import Mock from './mock';
//Mock.init();
import store from './store/index'
import VueResourceConfig from './resource/index'
import CsUI from './components/index'
import config from './config/config'
import VueCookie from 'vue-cookie'
import jq from 'jquery'
import './assets/font/iconfont.css'
// Vue.use(ViewUI);
import VueCountUp from 'vue-countupjs'
Vue.use(VueCountUp)

import TokenHandler from './shiro/TokenHandler.js'
Vue.prototype.$TokenHandler = TokenHandler;
// Vue.use(TokenHandler)

import request from './views/diagnose/request.js'
Vue.prototype.$request = request;

Vue.config.productionTip = false
Vue.use(CsUI)

Vue.prototype.resetSetItem = function (key, newVal) {
	if (key === 'orgName' || key === 'userType') {
		//创建一个StorageEvent事件
		var newStorageEvent = document.createEvent('StorageEvent');
		const storage = {
			setItem: function (k, val) {
				sessionStorage.setItem(k, val);
				newStorageEvent.initStorageEvent('set' + k, false, false, k, null, val, null, null);
				window.dispatchEvent(newStorageEvent);
			}
		}
		return storage.setItem(key, newVal);
	}
}

import theme from './assets/css/index.scss'
import './assets/js/rem'

var vm = new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})

//判断:当前元素是否是被筛选元素的子元素
jq.fn.isChildOf = function (b) {
	return (this.parents(b).length > 0);
};
//判断:当前元素是否是被筛选元素的子元素或者本身
jq.fn.isChildAndSelfOf = function (b) {
	return (this.closest(b).length > 0);
};



// WEBPACK FOOTER //
// ./src/main.js